import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list2: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/study/attend/list2", params, successCallback, failCallback, exceptionCallback);
	},listMthInClz: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/study/attend/listMthInClz", params, successCallback, failCallback, exceptionCallback);
	},
	toParse: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/study/attend/toParse", params, successCallback, failCallback, exceptionCallback);
	},
	toComfirm2: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/study/attend/toComfirm2", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
